module.exports = __webpack_public_path__ + "img/book.0bf30043.png";